import React, { PureComponent } from "react";
import { Icon, Radio } from "semantic-ui-react";
import html2canvas from "html2canvas";
import moment from "moment";
import DimmerComponent from "../../../../../Dashboard/DimmerComponent";
import { downloadCSVData, downloadCanvasWithTitle } from "../../../../../Dashboard/Charts/utils";
import { ReactComponent as MoreOptions } from "../../../../../../../assets/svg/menu.svg";
import ChartOptionsSidebar from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/ChartOptionsSidebar";
import CustomCheckBox from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/CustomCheckBox";
import FBIntervalSelector from "../../../../../FbInsights/FBIntervalSelector";
import ChartName from "../../../../../Dashboard/Charts/ChartName";
import DeleteWidget from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../../../assets/svg/settings.svg";
import { ReactComponent as ArrowIcon } from "../../../../../../../assets/svg/chevron.svg";
import { ChartFilterIcon } from "../../../../../Dashboard/Charts/ChartFilterOptions";
import LikesOverTimeChart from "./LikesOverTimeChart";
import TwitterPageSelector from "../TwitterPageSelector";
import { ReactComponent as MiniMize } from "../../../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import DownloadChart from "../../../../../Dashboard/Charts/DownloadChart";
class LikesOvertime extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            downloading: false,
            showAverage: true,
        };

        this.chart = React.createRef();
    }

    renderDownloadButton = (nodata) => {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: this.downloadCSV },
                    { name: "PNG", downloadFn: this.downloadPNG, showLoader: true },
                ]}
            />
        );
    };

    downloadPNG = (cb) => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }

        if (this.chart?.current)
            return html2canvas(this.chart.current, { backgroundColor: "#fff", allowTaint: true, useCORS: true, scrollX: 0, scrollY: -window.scrollY }).then(
                (canvas) => {
                    cb && cb();

                    downloadCanvasWithTitle(canvas, `${this.props.widget?.name || "Likes over Time"}`);
                },
            );
    };

    downloadCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        this.setState({ downloading: true });
        let data = this.props.data.data;

        let columns;

        columns = [["Time"], ["Likes"]];

        data.map((datArray) => {
            columns[0].push(datArray[0]);
        });

        let formatString = "YYYY-MM-DD HH:mm";

        data?.map((datArray) => {
            if (datArray) columns[1].push(datArray[1]);
        });
        let total = data.map((x) => x[1]).reduce((x, y) => x + y, 0);
        columns[1].push(total);

        columns[0] = columns[0].map((d) => (d === "Time" ? "Time" : moment(d).startOf("day").format(formatString)));
        columns[0].push("Total");
        columns[0].push("Average");
        columns[1].push(this.props.data.avg_value);

        let csvFmt = columns[0].map((col, i) => columns.map((row) => row[i]));

        this.setState({ downloading: false });
        downloadCSVData(csvFmt, `${this.props.widget?.name || "Likes over Time"}`);
    };

    increment = () => {
        if (this.props.twitterPageList.length === 1) return;
        let index;
        this.props.twitterPageList.map((value, ind) => {
            if (value.value === this.props.selectedTwitterPage.value) index = ind;
        });
        if (index === this.props.twitterPageList.length - 1) this.props.setSelectedTwitterPage(this.props.twitterPageList[0]);
        else this.props.setSelectedTwitterPage(this.props.twitterPageList[index + 1]);
    };

    decrement = () => {
        if (this.props.twitterPageList.length === 1) return;
        let index;
        this.props.twitterPageList.map((value, ind) => {
            if (value.value === this.props.selectedTwitterPage.value) index = ind;
        });
        if (index === 0) this.props.setSelectedTwitterPage(this.props.twitterPageList[this.props.twitterPageList.length - 1]);
        else this.props.setSelectedTwitterPage(this.props.twitterPageList[index - 1]);
    };

    getChart() {
        return (
            <>
                <div className="dashboard-chart dashboard-chart-slider skiptranslate" ref={this.chart}>
                    {!this.props.isTWPage && (
                        <div
                            data-html2canvas-ignore="true"
                            className={`chart-slider chart-slider-left ${this.props.twitterPageList?.length === 1 ? "disabled" : ""}`}
                            onClick={this.decrement}>
                            <ArrowIcon />
                        </div>
                    )}
                    <div className="chart-area">
                        {!this.props.isTWPage && this.props.selectedTwitterPage && (
                            <TwitterPageSelector
                                selectedTwitterPage={this.props.selectedTwitterPage}
                                setSelectedTwitterPage={this.props.setSelectedTwitterPage}
                                twitterPageList={this.props.twitterPageList}
                                widgetContainerRef={this.props.widgetContainerRef}
                            />
                        )}

                        <LikesOverTimeChart
                            showGridLines={this.props.showGridLines}
                            showLegend={this.props.showLegend}
                            isNoData={this.isNoData}
                            selectedTwitterPage={this.props.selectedTwitterPage}
                            graph_type={this.props.graph_type}
                            data={this.props.data}
                            error={this.props.error}
                            resizedCount={this.props.resizedCount}
                            isTWPage={this.props.isTWPage}
                            pageStatus={this.props.pageStatus}
                            widgetContainerRef={this.props.isTWPage ? this.chart : this.props.widgetContainerRef}
                            showAverage={this.state.showAverage}
                        />
                    </div>
                    {!this.props.isTWPage && (
                        <div
                            data-html2canvas-ignore="true"
                            className={`chart-slider chart-slider-right ${this.props.twitterPageList?.length === 1 ? "disabled" : ""}`}
                            onClick={this.increment}>
                            <ArrowIcon />
                        </div>
                    )}
                </div>
            </>
        );
    }

    isNoData = () => {
        const data = this.props.data;
        return this.props.pageStatus || (data && data.data.length > 0 ? false : true);
    };

    render() {
        const elements = (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName
                        isTwitter
                        isTWPage={this.props.isTWPage}
                        name={this.props.widget?.name || "Likes over Time"}
                        info="This graph shows the number of times people have engaged with your tweet through likes. The average line shows the average likes per tweet for tweets that were published for the date range selected."
                    />
                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        {!this.isNoData() && (
                            <div className="chart-type">
                                <span
                                    data-html2canvas-ignore="true"
                                    onClick={() => this.props.changeGraphType("bar")}
                                    className={this.props.graph_type === "bar" ? "active-chart" : ""}>
                                    <Icon name="bar chart" />
                                </span>
                                <span
                                    data-html2canvas-ignore="true"
                                    onClick={() => this.props.changeGraphType("line")}
                                    className={this.props.graph_type === "line" ? "active-chart" : ""}>
                                    <Icon name="line chart" />
                                </span>
                            </div>
                        )}
                        {!this.props.isTWPage &&
                            !this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    data-html2canvas-ignore="true"
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && !this.isNoData() && this.renderDownloadButton()}
                        {
                            <>
                                {(this.props.isPublic && this.isNoData()) || this.props.isTWPage ? null : (
                                    <Popup
                                        className="skiptranslate"
                                        trigger={
                                            this.props.expandWidget ? (
                                                <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            ) : (
                                                <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            )
                                        }
                                        inverted
                                        content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                        size="mini"
                                        position="bottom center"
                                        style={{ zIndex: "99999" }}
                                    />
                                )}
                            </>
                        }

                        {this.props.isPublic && this.isNoData() ? null : (
                            <MoreOptions
                                data-html2canvas-ignore="true"
                                className={this.isNoData() && this.props.isTWPage ? "pointer-disabled" : "more-options"}
                                onClick={(e) => this.props.changeShowMoreOptions(e)}
                            />
                        )}
                    </div>

                    {this.props.showMoreOptions && (
                        <ChartOptionsSidebar
                            data-html2canvas-ignore="true"
                            showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                            changeShowMoreOptions={this.props.changeShowMoreOptions}>
                            {!this.isNoData() && (
                                <>
                                    <CustomCheckBox checked={this.props.showLegend} onClick={this.props.changeShowLegend} label="Show Legends" />
                                    <CustomCheckBox label="Show Grid Lines" checked={this.props.showGridLines} onClick={this.props.changeShowGridLines} />
                                    <CustomCheckBox
                                        label="Show Average"
                                        checked={this.state.showAverage}
                                        onClick={() => this.setState({ showAverage: !this.state.showAverage })}
                                    />
                                    <FBIntervalSelector
                                        aggs_val={this.props.aggs_val}
                                        appliedFilter={this.props.appliedFilter}
                                        handleIntervalChange={this.props.handleIntervalChange}
                                    />
                                </>
                            )}
                            {!this.props.isTWPage &&
                                !this.props.isPublic &&
                                !this.props.isStandardDashboard &&
                                !this.props.isResearchDashboard &&
                                this.props.dashboardPageType !== "temporaryInsights" &&
                                this.props.dashboardPageType !== "temporary" && (
                                    <>
                                        <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                            <span>Chart Configuration</span>
                                            <Settings />
                                        </div>
                                        <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                            <span>Clone Chart</span>
                                            <CloneIcon />
                                        </div>
                                        <DeleteWidget onClick={this.props.deleteWidget} />
                                    </>
                                )}
                        </ChartOptionsSidebar>
                    )}
                </div>
                {this.getChart()}
                {(this.state.downloading || !this.props.selectedTwitterPage || this.props.loading) && <DimmerComponent />}
            </>
        );

        return this.props.isTWPage ? <div className="dashboard-widget-container">{elements}</div> : <>{elements}</>;
    }
}

export default LikesOvertime;
